import Avatar, { AvatarProps } from '@/components/elements/Avatar';
import Jazzicon from '@metamask/jazzicon';
import { useEffect, useRef } from 'react';

export type UserAvatarProps = { size?: number; walletAddress: string } & Omit<
  AvatarProps,
  'size'
>;

/**
 * @component UserAvatar
 */
function UserAvatar({ size = 32, walletAddress, ...rest }: UserAvatarProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (walletAddress && ref.current) {
      ref.current.innerHTML = ``;
      ref.current.appendChild(
        Jazzicon(size, parseInt(walletAddress.slice(2, 10), 16)),
      );
    }
  }, [walletAddress]);
  return <Avatar style={{ width: size, height: size }} ref={ref} {...rest} />;
}

export default UserAvatar;
